const styles = theme => ({
    ResultsContainer: {
        minHeight: '200px',
//        maxHeight: '90%',
        maxHeight: '500px',
        overflowY: 'scroll',
    },
    header3: {
        width: '80%',
        padding: '10px 20px',
        backgroundColor: 'rgba(23, 232, 51, 1)',
        color: 'white',
        display: 'flex',
        justifyContent: 'center'
    },
    resultsRoot: {
        width: '90%',
        height: 'auto',
        margin: '10px 10px',
        boxShadow: '2px 2px 5px rgba(200,200,200,0.6)',
        position: 'relative',
        padding: '10px 10px'
    },
    gridList: {
        width: '100%',
        overflowY: 'scroll',
        margin: '10px 10px'
    },
    imageTile: {
		maxHeight: '200px',
        height: 'available',
        fallbacks: [
            {height: '-webkit-fill-available'},
            {height: '-moz-fill-available'},
            {height: 'fill-available'},
        ],
        position: 'relative',
        '&:hover':{
            cursor: 'pointer'  
        },
        margin: '10px'
    },
    imageTile2: {
        padding: '5px 5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover':{
            cursor: 'pointer',
            boxShadow: '5px 5px 12px -5px  rgba(173,173,173,1)'
        },
        // margin: '10px'
    },
    preview: {
        position: 'absolute',
        maxHeight: '100%',
        maxWidth: '100%',
        margin: 'auto',
        top: '0px',
        bottom: '0px',
        left: '0px',
        right: '0px',
    },
    preview2: {
        display: 'block',
        maxHeight: '100%',
        maxWidth: '100%',
        width: 'auto',
        height: 'auto'
    },
    tableHeader: {
        position: "sticky", 
        top: 0, 
        background: 'white',
        fontWeight: 'bold'
    },
    downloadButton: {
        position: 'sticky', 
        top: 2*theme.spacing.unit,
        left: 2*theme.spacing.unit,
        zIndex: '5',
        '&:disabled': {
            backgroundColor: 'rgba(240, 240, 240, 1)',
        }
    },
    downloadButtonDisabled: {
        backgroundColor: 'rgba(240, 240, 240, 1)',
        opacity: 1,
        zIndex: '5',
    },
    gridListRoot: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        alignItems: 'space-around'
    },
    tooltip: {
        maxWidth: 'none'
    },
    loading: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    }
});

export default styles;
